import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.598 25.038C7.69 26.742 9.102 28 10.808 28h10.384c1.706 0 3.118-1.258 3.21-2.962.09-1.645.17-4.037.17-7.324 0-2.863-.061-4.894-.136-6.31-.1-1.889-1.262-3.403-3.135-3.665-1.239-.174-2.958-.31-5.301-.31s-4.062.136-5.301.31C8.826 8 7.663 9.515 7.564 11.404c-.075 1.416-.135 3.447-.135 6.31 0 3.287.08 5.679.169 7.324Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.429 17.93c-.53.035-.972.07-1.337.105-.973.09-1.752.71-1.897 1.676-.107.714-.195 1.731-.195 3.146 0 1.131.056 2.06.134 2.8C4.283 27.085 5.52 28 6.954 28h3.802M21.245 28h3.801c1.434 0 2.672-.916 2.821-2.342.077-.741.134-1.67.134-2.802 0-1.414-.088-2.431-.195-3.145-.145-.966-.924-1.586-1.897-1.676-.365-.034-.807-.07-1.337-.104M19.416 7.543C19.309 5.528 18.048 4 15.998 4s-3.311 1.528-3.418 3.543M7.442 15.429s2.655.448 6.846.55M17.71 15.98c4.192-.103 6.846-.551 6.846-.551"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.291 16.645c.015.906.558 1.616 1.464 1.638a10.009 10.009 0 0 0 .49 0c.907-.022 1.45-.732 1.465-1.639a39.657 39.657 0 0 0 0-1.288c-.015-.907-.558-1.617-1.465-1.639a10.026 10.026 0 0 0-.49 0c-.906.022-1.45.732-1.464 1.639a39.648 39.648 0 0 0 0 1.289Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "handbag"}) } }